import { InputItem } from "pepsico-ds";
import Table from "../../../components/common/table/Table";
import { HEADER_DATA, MESSAGES, STYLES, TABLE_CONFIG } from "./constants";
import "./keywordManagement.scss";
import { transformKeywordsToRowData } from "./utils";

const KeywordsTable = ({
  keywords,
  loading,
  searchTerm,
  handleEdit,
  handleSoftDelete,
  handleSearchChange,
}) => {
  const rowData = transformKeywordsToRowData(keywords, handleEdit, handleSoftDelete);

  if (loading) {
    return <div style={STYLES.loadingContainer}>{MESSAGES.LOADING}</div>;
  }

  return (
    <div className="keywords-table-container">
      <div className="keywords-table-header">
        <div className="keywords-table-search">
          <InputItem
            placeholder={TABLE_CONFIG.SEARCH_PLACEHOLDER}
            trailingIcon="search"
            size="medium"
            className="input-search"
            onChange={handleSearchChange}
            value={searchTerm}
          />
        </div>
      </div>
      <Table
        headerData={HEADER_DATA}
        rowData={rowData}
        className="keywords-table"
        pagination={true}
        rowsPerPage={TABLE_CONFIG.ROWS_PER_PAGE}
        noDataLabel={TABLE_CONFIG.NO_DATA_LABEL}
      />
    </div>
  );
};

export default KeywordsTable;
